<template>
  <div>
    <b-progress height="5px" :value="progressValue" :max="updateIntervalSec*10"></b-progress>
    <b-overlay :show="isBusy || isBusyInner " >
      <b-table      
        ref="table-transition"
        hover 
        striped 
        :borderless="false"
        small 
        sort-icon-left
        no-local-sorting 
        responsive
        id="table-transition"
        :tbody-transition-props="effectsEnable ? { name: 'flip-list' } : null"
        :primary-key="primaryKey"

        :items="itemsInner" 
        :fields="captions" 
        :busy="false" 
        :per-page="perPage"

        @sort-changed="$emit('onSortHeadClicked', $event)" 
        @row-clicked="rowClicked"
        @row-dblclicked="rowDblClicked">

        <template #cell(details)="row">
          <button-additional-info @click="effectsEnable=false; row.toggleDetails()"/>
        </template>

        <template #cell(actions)="row">
          <div class="d-flex flex-row-reverse">
            <slot name="actions" :item="row.item"></slot>
          </div>
        </template>

        <template v-for="(_, slot) of $slots" :slot="slot">
          <slot :name="slot"/>
        </template>

        <template v-for="(_, slot) of $scopedSlots" #[slot]="scope">
          <slot :name="slot" v-bind="scope"/>
        </template>
        
        <!--<template #table-busy>
          <waiting-form/>
        </template>-->

      </b-table>
    </b-overlay>

    <b-pagination 
      :disabled="isBusy || isBusyInner"
      align="center"       
      limit=10 
      page 
      pills 
      first-number 
      last-number 
      :total-rows="totalItems" 
      :per-page="perPage" 
      v-model="currentPage" 
      @input="getData(false)"
    />

    <b-modal 
      centered 
      :id="'modal-export-table-data-count'+exportModalCountId"
      :title="'Выберите количество записей из ' + totalItems" 
      class="modal-primary" 
      size="md"
      header-bg-variant="primary"
      ok-variant="primary"
      ok-only
      @ok="onModalExportExcellCountClick"
    >
      <template #modal-ok>Загрузить</template>      
      <div class="d-flex flex-row">
        <b-input-group class="mb-1" prepend="Страница" append="">
          <b-form-input v-model.number="exportPage" type="number" min="1"/>
        </b-input-group> 
        <b-input-group class="mb-1 ml-2" prepend="Количество" append="">
          <b-form-input v-model.number="exportCount" type="number" min="1" max="1000"/>
        </b-input-group> 
      </div>
    </b-modal>

    <field-selector-modal 
      :id="'modal-export-table-data'+exportModalId" 
      title="Экспорт в Excell" 
      :itemsIn="exportItemsIn" 
      v-model="exportParams" 
      @okClick="onModalExportExcellClick"/>
  </div>
</template>

<script>

import WaitingForm from '@/views/components/WaitingForm.vue'
import ExportJsonExcel from 'js-export-excel'
import FieldSelectorModal from '@/views/export/FieldSelectorModal.vue'

export default {
  name: 'page-table',
  inheritAttrs: false,
  components: {WaitingForm, FieldSelectorModal},
  props: {
    fields: {
      type: [Array, Function],
      default: () => []
    },

    hideFields: {
      type: [Array, Function],
      default: () => []
    },

    primaryKey: {
      type: String,
      default: 'id'
    },

    updateIntervalSec: {
      type: Number,
      default: 60
    },

    getDataFunction: {
      type: Function,
      default: null
    },

    getDataFunctionParam: {
      type: Object,
      default: null
    },

    isBusy: {
      type: Boolean,
      default: false
    },

    isSortable: {
      type: Boolean,
      default: true      
    },

    perPage: {
      type: Number,
      default: 15
    }
  },
  
  data: () => {
    return {
      isBusyInner: false,

      captions: [],
      items: [],
      itemsInner: [],
      totalItems: 0,

      //perPage: 15,
      currentPage: 1,
      
      effectsEnable: true,
      timerId: null,
      animateRefresh: false,
      progressValue: 0,
      timerCounter: 0,

      exportPage: 1,
      exportCount: 100,
      exportParams: {
        format: "xls",
        dataOut: [],
      },
      exportItemsIn: [],
      exportModalCountId: '',
      exportModalId: '',
    }
  },

  watch: {
    fields() {
      this.recalculateCaptions()
    },

    hideFields() {
      this.recalculateCaptions()
    },

    updateIntervalSec() {
      if (this.updateIntervalSec > 0) {
        this.startTimer()
      }
      else {
        this.stopTimer();
      }
    },

    items(newItems, oldItems) {
      let detailsOpen = false
      this.itemsInner.forEach(e => {
        if(e._showDetails) {
          detailsOpen = true
        }
      })

      if (detailsOpen) {
        if (JSON.stringify(newItems) !== JSON.stringify(oldItems)) {
          this.animateRefresh = true
        }
      }
      else {        
        this.animateRefresh = false
        this.itemsInner = JSON.parse(JSON.stringify(newItems));
      }

      this.$emit('animateRefresh', this.animateRefresh)
    },

    isSortable() {
      this.recalculateCaptions()
    }
  },

  methods: {
    rowClicked(event) {
      if (this.$store.getters.isMobile) {
        this.$emit('rowClicked', event)
      }
    },

    rowDblClicked(event) {
      if (!this.$store.getters.isMobile) {
        this.$emit('rowClicked', event)
      }
    },

    recalculateCaptions() {
      this.captions = []      

      this.fields.forEach(e => {
        if (!this.isSortable) {
          e.sortable = false
        }

        if(this.hideFields.findIndex(f => f === e.key) === -1) {
          this.captions.push(e)
        }
      }); 
    },

    getItems() {
      return this.itemsInner
    },

    getData(effectsEnable) {
      if (effectsEnable === undefined || effectsEnable == null) {
        effectsEnable = false // effectsEnable = true
      }

      this.itemsInner.forEach(e => {
        e._showDetails = false
      })

      this.getDataInner(true, effectsEnable) 
    },

    getExcellData() {
      this.$bvModal.show('modal-export-table-data-count'+this.exportModalCountId)
    },

    onModalExportExcellCountClick() {
      this.isBusyInner = true
      this.$emit('onBusy', this.isBusyInner)
      
      if(this.exportPage < 0) {
        this.exportPage = 1
      }

      if(this.exportCount < 0) {
        this.exportCount = 1
      }

      if(this.exportCount > 1000) {
        this.exportCount = 1000
      }

      this.getDataFunction(this.exportPage, this.exportCount, this.getDataFunctionParam)
      .then(response => {        
        this.isBusyInner = false
        this.$emit('onBusy', this.isBusyInner)
        if (response != null && response.data !== null) {
          console.log(response.data.total)
          //console.log(response.data.data)          

          let obj = response.data.data[0]
          if (!obj) return

          response.data.data.forEach(item => {
            Object.keys(item).forEach(prop => {
              if (item[prop] === true) {
                item[prop] = 'да'
              }

              if (item[prop] === false) {
                item[prop] = 'нет'
              }
            })
          })

          this.exportItemsIn = []
          Object.keys(obj).forEach(e => {
            this.exportItemsIn.push({id: e, name: e, default: e.substring(0, 2) !== 'id'})
          })

          this.exportExcelData = response.data.data
          this.$bvModal.show('modal-export-table-data'+this.exportModalId)
        }          
      })
      .catch((ex) => {
        console.log(ex)
        this.isBusyInner = false
        this.$emit('onBusy', this.isBusyInner)
      })
    },

    onModalExportExcellClick() {
      var option = {fileName: 'ExportTable.xls'}
      
      let filter = []
      let header = []
      let columnWidths = []
      this.exportParams.dataOut.forEach(e => {
        filter.push(e.id)
        header.push(e.name)
        columnWidths.push('')
      })

      option.datas = [
        {
          sheetData: this.exportExcelData,
          sheetName: "sheet",
          sheetFilter: filter,
          sheetHeader: header,
          columnWidths: columnWidths
        },
      ];
      
      var toExcel = new ExportJsonExcel(option); //new
      toExcel.saveExcel(); 
    },

    getDataInner(tableBusy, effectsEnable) {
      this.effectsEnable = effectsEnable
      if (tableBusy === undefined || tableBusy === null) {
        tableBusy = true
      }
      this.isBusyInner = tableBusy
      this.$emit('onBusy', this.isBusyInner)
      this.getDataFunction(this.currentPage, this.perPage, this.getDataFunctionParam)
      .then(response => {        
        this.isBusyInner = false
        this.$emit('onBusy', this.isBusyInner)
        if (response != null && response.data !== null) {
          this.items = response.data.data
          this.totalItems = response.data.total
          this.$emit('dataChanged', {items: response.data.data, totalItems: response.data.total})
        }          
      })
      .catch((ex) => {
        console.log(ex)
        this.isBusyInner = false
        this.$emit('onBusy', this.isBusyInner)
      })
    },

    startTimer() {
      this.progressValue = 0
      this.timerCounter = 0
      this.stopTimer()

      let self = this
      this.timerId = setTimeout(function tick() 
        {          
          self.progressValue ++

          self.timerCounter++
          if (self.timerCounter > self.updateIntervalSec*10){
            self.progressValue = 0
            self.timerCounter = 0
            self.isTimerEvent = true
            //if (self.currentPage === 1) {
              self.getDataInner(false, true)
            //}
          }
          
          self.timerId = setTimeout(tick, 100);
        }, 
        100
      );
    },

    stopTimer() {      
      clearTimeout(this.timerId)
      this.progressValue = 0
    }
  },

  activated() {
  },

  deactivated() {
    this.stopTimer()
  },

  mounted() {
    this.exportModalCountId = String(Math.random()) // crypto.randomUUID()
    this.exportModalId = String(Math.random()) //crypto.randomUUID()
    //console.log(this.exportModalCountId, this.exportModalId)

    this.recalculateCaptions()
    this.getData(false)
  },

  beforeDestroy() {
    this.stopTimer()
  }
}
</script>

<style>
  table#table-transition .flip-list-move {
    transition: transform 1s;    
  }

 .table#table-transition .flip-list-enter-active {    
    transition: all 1s, background-color 2s;
    transition-delay: 0.3s;
  }

  table#table-transition .flip-list-enter {
    opacity: 0;
    transform: translateX(50px);
    background-color: yellow;
  }

  table#table-transition .flip-list-leave-active {
    display: none;    
  }

  table#table-transition .flip-list-leave-to {
    display: none;
  }

</style>